/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { cached } from '@glimmer/tracking';
import PhClock from 'ember-phosphor-icons/components/ph-clock';
import PhCheckCircle from 'ember-phosphor-icons/components/ph-check-circle';
import { LockCodeStatus } from 'uplisting-frontend/models/lock-code';

interface IArgs {
  pin: string;
  status: LockCodeStatus;
}

interface BookingStatusLockCodeSignature {
  Element: HTMLDivElement;

  Args: IArgs;
}

export default class UiBookingStatusLockCodeComponent extends Component<BookingStatusLockCodeSignature> {
  @cached
  get status(): LockCodeStatus {
    return this.args.status;
  }

  @cached
  get alertClass(): 'inline-alert-processing' | 'inline-alert-success' {
    switch (this.status) {
      case LockCodeStatus.pending:
      case LockCodeStatus.awaiting:
        return 'inline-alert-processing';
      case LockCodeStatus.confirmed:
        return 'inline-alert-success';
    }
  }

  @cached
  get iconComponent(): typeof PhCheckCircle | typeof PhClock | undefined {
    switch (this.status) {
      case LockCodeStatus.confirmed:
        return PhCheckCircle;
      case LockCodeStatus.pending:
      case LockCodeStatus.awaiting:
        return PhClock;
    }
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Ui::Booking::Status::LockCode': typeof UiBookingStatusLockCodeComponent;
  }
}
